import styled from '@emotion/styled';

export const StyledHero = styled.div`
  min-height: 100vh;
  width: 100%;
  background: radial-gradient(
    108.12% 88.53% at 101.6% -1.99%,
    #17557d 0.52%,
    #070a1e 100%
  );
  overflow: hidden;
  position: relative;
  padding-bottom: 32px;

  ${(props) => props.theme.breakpoints.up('md')} {
    padding-bottom: 64px;
  }
`;

export const StyledLinesWrapper = styled.div`
  margin-top: 24px;
  position: absolute;
  top: 92px;
  left: 0;
  z-index: 0;

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`;

export const StyledContent = styled.div`
  z-index: 3;
`;

export const StyledMapWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('images/map.svg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }

  &:before {
    content: '';
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    background: linear-gradient(
      90deg,
      #070a1e 0%,
      rgba(39, 39, 39, 0) 50.52%,
      rgba(7, 10, 30, 0.6) 100%
    );
    opacity: 0.3;
  }

  &:after {
    content: '';
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 56.25%,
        rgba(0, 0, 0, 0.2) 82.81%
      ),
      rgba(7, 10, 30, 0.4);
  }
`;
